import { createSlice } from "@reduxjs/toolkit";
import {
  getDefaultPayment,
  getPlanInformation,
  updatePayment,
  switchPlan,
  cancelPlan,
  unCancelSubscription,
} from "./thunk";
import { toast } from "react-toastify";
import { removeUserData } from "../../utils/StorageManager";
export const initialState = {
  billing: null,
  planInformation: null,
  subscriptionPayment: {
    issuer: "visa",
    type: "Subscription",
    name: "Koji Preston",
    card: "Visa",
    last4: "0157",
    expMonth: "3",
    expYear: "2026",
  },
  purchasePayment: {
    issuer: "visa",
    type: "Subscription",
    name: "Koji Preston",
    card: "Visa",
    last4: "0157",
    expMonth: "3",
    expYear: "2026",
  },
  error: null,
  loading: false,
  updating: false,
};

const BillingSlice = createSlice({
  name: "BillingSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getDefaultPayment.pending, (state) => {
      state.loading = true;
      state.subscriptionPayment = {};
      state.purchasePayment = {};
      state.error = null;
    });

    builder.addCase(getDefaultPayment.fulfilled, (state, action) => {
      const data = Array.isArray(action.payload?.data) ? action.payload.data : [];
      state.subscriptionPayment = data.filter(
        (item) => item.type === "Subscription"
      )[0];
      state.purchasePayment = data.filter(
        (item) => item.type === "Purchases"
      )[0];
      state.loading = false;
    });

    builder.addCase(getDefaultPayment.rejected, (state, action) => {
      //  state.error = action.payload.error || null;
    });

    builder.addCase(updatePayment.pending, (state) => {
      toast.loading("Updating Payment...", {
        position: "top-center",
      });
      state.planInformation = null;
      state.error = null;
    });
    builder.addCase(updatePayment.fulfilled, (state, action) => {
      toast.dismiss();
      document.location.href = action.payload.data;
    });

    builder.addCase(updatePayment.rejected, (state, action) => {
      // state.error = action.payload.error || null;
    });

    builder.addCase(getPlanInformation.pending, (state) => {
      state.planInformation = null;
      state.error = null;
      state.loading = true;
    });

    builder.addCase(getPlanInformation.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.success) state.planInformation = action.payload.data;
      else state.error = action.payload.message;
    });
    builder.addCase(getPlanInformation.rejected, (state, action) => {
      state.loading = false;
      //  state.error = action.payload.error || null;
    });

    builder.addCase(switchPlan.pending, (state) => {
      toast.dismiss();
      state.planInformation = null;
      state.error = null;
      state.updating = false;
    });
    builder.addCase(switchPlan.fulfilled, (state, action) => {
      state.updating = true;
      toast.dismiss();
      if (action.payload.success) {
        state.planInformation = action.payload.data;
        toast.success("Plan Switched Successfully", {
          position: "top-center",
        });
      } else {
        toast.error(action.payload.message, {
          position: "top-center",
        });
      }
    });
    builder.addCase(switchPlan.rejected, (state, action) => {
      toast.dismiss();
      // state.error = action.payload.error || null;
    });

    builder.addCase(cancelPlan.pending, (state) => {
      toast.dismiss();
      state.planInformation = null;
      state.error = null;
      state.updating = false;
    });

    builder.addCase(cancelPlan.fulfilled, (state, action) => {
      toast.dismiss();
      if (action.payload.success) {
        if (action.message === "Redirect") {
          removeUserData();
          window.location.href = "/login";
        }
        state.updating = true;
        state.planInformation = action.payload.data;
        toast.success("Plan Cancelled Successfully", {
          position: "top-center",
        });
      } else {
        toast.error(action.payload.message, {
          position: "top-center",
        });
      }
    });
    builder.addCase(cancelPlan.rejected, (state, action) => {
      toast.dismiss();
      // state.error = action.payload.error || null;
    });

    builder.addCase(unCancelSubscription.pending, (state) => {
      toast.dismiss();
      state.planInformation = null;
      state.error = null;
      state.updating = false;
    });
    builder.addCase(unCancelSubscription.fulfilled, (state, action) => {
      toast.dismiss();
      if (action.payload.success) {
        // Check if there's a redirect URL
        if (action.payload.redirectUrl) {
          document.location.href = action.payload.redirectUrl;
          return;
        }
        state.updating = true;
        state.planInformation = action.payload.data;
        toast.success("Plan resumed Successfully", {
          position: "top-center",
        });
      } else {
        toast.error(action.payload.message, {
          position: "top-center",
        });
      }
    });

    builder.addCase(unCancelSubscription.rejected, (state, action) => {
      toast.dismiss();
      // state.error = action.payload.error || null;
    });
  },
});

export default BillingSlice.reducer;
